<script lang="ts">
    import { onMount } from 'svelte';
    import { getJetPerform } from '~/jet';
    import { loggerFor } from '@amp/web-apps-logger';
    import { getCommerce, CommerceRoute } from '~/utils/commerce';
    import { getLocale } from '~/utils/locale';
    import { isPremiumSubscriber } from '~/utils/user';
    import { NON_SOW_COUNTRIES } from '~/constants/storefront';
    import { getI18n } from '~/stores/i18n';
    import { needsGDPR } from '@amp/web-app-components/src/stores/needs-gdpr';
    import { loadMusicUpsellBanner } from '~/utils/external/cwc-components';
    import {
        CommerceModalActionOperationType,
        makeCommerceModalAction,
    } from '~/actions/commerce-modal-action';
    // import { tryItNowLaunchApp } from '~/utils/launch-utils';

    const i18n = getI18n();
    const log = loggerFor('<UpsellBanner>');
    const locale = getLocale();
    const { state } = getCommerce();
    const perform = getJetPerform();

    // Explicit check for `upsellOfferDetails &&` because we do not want to show banner till User get info API call is complete
    $: upsellOfferDetails = $state.upsellOfferDetails;
    $: showBanner =
        !$needsGDPR &&
        upsellOfferDetails &&
        !isPremiumSubscriber($state.user?.subscriberType);
    $: activeStorefront =
        $state.user?.subscriptionStorefront || locale.storefront;

    const handleCtaClick = () => {
        const canSubscribe = !NON_SOW_COUNTRIES.includes(activeStorefront);
        if (canSubscribe) {
            const openUpsell = makeCommerceModalAction({
                type: CommerceModalActionOperationType.Open,
                activePath: CommerceRoute.subscribe,
            });
            perform(openUpsell);
        } else {
            // TODO rdar://139014122 ([Classical on Web] Implement Launching Native App from Upsell Banner for a Deeplink URL)
            // tryItNowLaunchApp();
        }
    };

    onMount(async () => {
        try {
            loadMusicUpsellBanner();
        } catch (e) {
            log.error('Loading CWC Music Upsell Banner Failed', e);
        }
    });
</script>

{#if showBanner}
    <div class="upsell-banner" data-testid="upsell-banner">
        <cwc-music-upsell-banner-web
            storefront={activeStorefront}
            is-intro-offer={upsellOfferDetails?.isIntroOffer}
            is-free-trial={upsellOfferDetails?.isFreeTrial}
            base-price-string={upsellOfferDetails?.basePriceString}
            is-classical={true}
            intro-period={$i18n.t(
                'ASE.Web.MusicClassical.Finance.Duration.Months',
                {
                    num: upsellOfferDetails?.introPeriod,
                    count: upsellOfferDetails?.introPeriod,
                },
            )}
            intro-price={upsellOfferDetails?.introPrice}
            on:cwcCtaClick={handleCtaClick}
        />
    </div>
{/if}

<style lang="scss">
    .upsell-banner {
        // TODO: rdar://98856238 (JMOTW: Sidebar content overlaps banners on short viewports)
        --musicBrandBG: var(--keyColorBG);
        grid-area: structure-upsell;
        position: relative;

        // Stacking context above sidebar navigation
        z-index: calc(var(--z-web-chrome) - 10);
    }
</style>
